import { capitalize, isObject, replace } from 'lodash';
import { JourneyConfig } from '../models/journey';

interface LabelsPayload {
  agent: string;
  task: string;
}

const updateLocales = (values: LabelsPayload, config: JourneyConfig) => {
  const agentLabel = config?.locales?.en?.driverWidget?.agentTitle;
  const taskLabel = config?.locales?.en?.orderWidget?.appointmentType;
  const { locales } = config;
  const updates = [{
    prev: agentLabel,
    next: values.agent,
  }, {
    prev: taskLabel,
    next: values.task,
  }];

  return JSON.parse(JSON.stringify(locales), (key, value) => {
    let result = value;
    if (isObject(result)) {
      return result;
    }
    updates.forEach((item) => {
      if (item.prev && item.next && item.prev !== item.next) {
        const reg = new RegExp(item.prev, 'gi');
        result = replace(result, reg, (match) => {
          if (match === capitalize(match)) {
            return capitalize(item.next);
          }
          return item.next.toLowerCase();
        });
      }
    });
    return result;
  });
};

export default updateLocales;
